import React, { useState } from "react";
import InView from "react-intersection-observer";
import ImageGreenBlackGradient from "../../../images/green-black-gradient-bg.png";
import HeaderAnim from "../utils/animations/textRevealAnimation";

function PageIntro(props) {
  const { header, subHeader, intro, classes } = props.data;
  const [isVisible, setIsVisible] = useState(false);

  return (
    <InView as='div' onChange={inView => setIsVisible(inView)} className={`intro-content-section section-gap-small ${classes}`} id={props.id ? props.id : ''}>
      <div className="container">

        <div className="row d-flex flex-wrap">
          <div className="col intro-leftbar">
            {header && <p className="theme-color-title">{isVisible && <HeaderAnim header={header} />}</p>}
            {subHeader && <h6 className="gredient-title h3">{subHeader}</h6>}
            {/*<img className="gredient-img" src={ImageGreenBlackGradient} />*/}
          </div>
          {intro && <div className="col intro-rightbar">
            {intro}
          </div>}
        </div>
      </div>
    </InView>
  );
}

export default PageIntro; 